// Per-school branding, set at build time via env vars (see /workspace/yoga-licence/how-to-brand.md)
const env = import.meta.env
export const BRAND = {
  name: (env.VITE_BRAND_NAME as string | undefined) || '',
  color: (env.VITE_BRAND_COLOR as string | undefined) || '',
  logo: (env.VITE_BRAND_LOGO as string | undefined) || '',
}
export const isBranded = Boolean(BRAND.name)
